import { Location } from '@angular/common';
import { Component, input, output, computed, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { UiService } from '../../services/ui.service';
import { I18nService } from '../../services/i18n.service';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { I18N_KEYS } from '../../enums/i18.enum';
import { APP_ROUTES } from '../../enums/routes.enum';
import { TabMenuComponent } from '../tab-menu/tab-menu';
import { BannerNotificationComponent } from '../banner-notification/banner-notification.component';
import { LP_UI_CONFIG } from '../../core/tokens';

@Component({
  selector: 'app-header',
  imports: [RouterModule, NzIconModule, TabMenuComponent, BannerNotificationComponent],
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
})
export class HeaderComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private ui = inject(UiService);
  private location = inject(Location);
  public i18n = inject(I18nService);

  transparent = input(false);
  overlap = input(false);
  title = input(GLOBAL_CONSTANT.EMPTY_STRING);
  noEditBtn = input(true);
  plantHeader = input(true);
  eqHeaderId = input<any>(GLOBAL_CONSTANT.EMPTY_STRING);
  plantHeaderId = input<number | string>(GLOBAL_CONSTANT.EMPTY_STRING);
  sensorHeaderIds = input<string[] | number[]>([
    GLOBAL_CONSTANT.EMPTY_STRING,
    GLOBAL_CONSTANT.EMPTY_STRING,
  ]);
  show4SensorDau = input(false);

  backLabel = input(this.i18n.langString('settings'));
  backRoute = input('');
  backButtonClickInstead = input(false);

  wizard = input(false);
  wizardsteps = input<string[]>([]);
  start = input(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  currentstep = input(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  currentstepError = input(false);
  noLabelWizard = input(false);
  overflowEnd = input(true);
  overflowStart = input(false);

  // ✅ Outputs
  wizardButtonClick = output<number>();
  backButtonClick = output<boolean>();

  public readonly cfg = inject(LP_UI_CONFIG);

  // ✅ Computed signals
  isDesktop = computed(() => this.ui.IsDesktop());
  isMobile = computed(() => this.ui.IsMobile());
  isTablet = computed(() => this.ui.IsTablet());

  isOnSettingsPage = computed(() => {
    return this.route.snapshot?.routeConfig?.path?.includes(GLOBAL_CONSTANT.SETTINGS) ?? false;
  });

  currentStepComputed = computed(() => {
    return this.wizardsteps().length - this.start();
  });

  back(): void {
    this.location.back();
  }

  toSettings(): void {
    this.router.navigate([APP_ROUTES.SETTING]);
  }

  onWizardButtonClick(i: number): void {
    this.wizardButtonClick.emit(i);
  }

  onBackButtonClick(): void {
    if (window.location.href.includes(GLOBAL_CONSTANT.SENSOR_CONNECT_V2)) {
      const currentAssetId = window.location.href.substring(
        window.location.href.lastIndexOf('/') + 1
      );
      this.router.navigate([APP_ROUTES.ASSET, currentAssetId]);
    } else {
      if (this.backButtonClickInstead()) {
        this.backButtonClick.emit(true);
      } else {
        this.router.navigate([this.backRoute()]);
      }
    }
  }
}
